export default {"src":"/_next/static/media/Handy-Pizza.879d95fa.svg","height":737,"width":709,"blurWidth":0,"blurHeight":0};